var _rect, _rect2, _path, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRateFace1On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 0.8,
    width: 30.4,
    height: 30.4,
    rx: 15.2,
    fill: "#FFD8E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 0.8,
    width: 30.4,
    height: 30.4,
    rx: 15.2,
    stroke: "#FF77B1",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.69 21.332L11.6328 21.3321",
    stroke: "#FF3D8F",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1541,
    cy: 12.1619,
    rx: 2.44122,
    ry: 2.56038,
    fill: "#FF3D8F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1697,
    cy: 12.1619,
    rx: 2.44122,
    ry: 2.56038,
    fill: "#FF3D8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRateFace1On);
export default __webpack_public_path__ + "static/media/icon-rate-face-1-on.b96fabbad497ae5a398d03d1d3410f54.svg";
export { ForwardRef as ReactComponent };